import { LinearGradient, Stack } from '@adc/parallax-component-library';

export const AppMenuItemIcon = () => (
  <LinearGradient
    colors={['#8A8A8A', '#757575']}
    start={{ x: 0, y: 0 }}
    end={{ x: 0, y: 1 }}
    borderRadius="$1.25"
    overflow="hidden"
  >
    <Stack width={31} height={31} />
  </LinearGradient>
);
